import type { BookableBookingObjectDto } from "../typings/resource-calendar.types";
import type { BookingResourceInfo } from "../typings/booking-resource-info.types";

/**
 * Catalog rows omit full inventory metadata. Stub allows confirm UI before detail fetch completes.
 */
export function createStubResourceInfoForResourceBooking(
  row: BookableBookingObjectDto
): BookingResourceInfo {
  return {
    id: row.bookingInventoryId,
    name: row.objectName,
    description: null,
    resourceKind: row.resourceKind ?? "equipment",
    locationName: row.locationName,
    floorName: row.floorName,
    categoryName: null,
    bookingLeadTime: null,
    pricePerUnit: null,
    picturePaths: null
  };
}
